export const skilldata=[
    {
        label:"LANGUAGES",
        data:[
            {
                skillname:"HTML",
                percentge:"80",
            },
            {
                skillname:"CSS",
                percentge:"70",
            }, {
                skillname:"Javascript",
                percentge:"80",
            }, {
                skillname:"C++",
                percentge:"90",
            }, {
                skillname:"ReactJs",
                percentge:"50",
            }, 
        ]
    },
    {
        label:"CORE SUBJECTS",
        data:[{
            skillname:"DBMS",
            percentge:"80",
        },
        {
            skillname:"Object oriented programming",
            percentge:"90",
        }, {
            skillname:"Operating System",
            percentge:"80",
        }, {
            skillname:"Computer Network",
            percentge:"70",
        }, {
            skillname:"Data Structure and Algorithm",
            percentge:"70",
        }, 
    ]

    },
    {
        label:"Developer Tools",
        data:[{
            skillname:"VS Code",
            percentge:"80",
        },
        {
            skillname:"Git/Github",
            percentge:"90",
        }, 
    ]

    }
]
